import { format, formatDistanceToNow, isToday, isYesterday } from "date-fns";
import { isNaN, isNil } from "lodash";

export const formatRelativeDateString = (date: Date) => {
  const now = new Date();

  const updatedAtDateObject = new Date(date);

  if (
    isNaN(updatedAtDateObject.getTime()) ||
    isNil(updatedAtDateObject.getTime())
  ) {
    return "Invalid Date";
  }

  if (isToday(updatedAtDateObject)) {
    return formatDistanceToNow(updatedAtDateObject, { addSuffix: true });
  } else if (isYesterday(updatedAtDateObject)) {
    return "Yesterday";
  } else if (updatedAtDateObject.getFullYear() === now.getFullYear()) {
    return format(updatedAtDateObject, "MMM dd");
  } else {
    return format(updatedAtDateObject, "MMM dd yyyy");
  }
};
